
import "./popupQuestion.scss";

import { Component } from "react";
import PopupManager from '../PopupManager';
import { CodeQuestions, CodesChoix, IQuestion, ListeCodesChoix, CodeQuestionListe } from '../../../interfaces/ILabyData';

import imageCoffreMobile from "../../../images/epreuve_bandeau_et_coffre.svg";
import imageCoffre from "../../../images/epreuve_coffre.svg";
import img_bulle_perso_pc from "../../../images/bulle_pensee_personnage_pc.svg";
import img_bulle_perso_mob from "../../../images/bulle_pensee_personnage_mob.svg";
import { createRef } from 'react';
import clsx from 'clsx';

interface IPopupQuestionProps{
    pm:PopupManager,
    valeur:number,
    code:CodeQuestions
}
type IPopupQuestionState = {
    currentQuestion:IQuestion|undefined;
    reponse:CodesChoix|null;
}

class PopupQuestion extends Component<IPopupQuestionProps,IPopupQuestionState> {

  pm:PopupManager;    
  valeur:number;
  code:CodeQuestions;
  en_jeu_ref_DOM = createRef<HTMLDivElement>();
  zonechoix_ref_DOM = createRef<HTMLDivElement>();
  
  constructor(props:any){
    super(props);
    this.state = this.getInitialState();
    this.pm = props.pm;
    this.valeur = props.valeur;
    this.code = props.code;
  }

  getInitialState():IPopupQuestionState{
    return(
        {
          currentQuestion:undefined,
          reponse:null
        }
    )
  }


  componentDidMount(){ 
    const niveau = this.pm.app.gameManager.current?.getCurrentNiveau() || 5;
    const nextQuestion = this.pm.app.gameManager.current?.questionManager.getNextQuestion(niveau);
    if (nextQuestion){
      this.setState({currentQuestion:nextQuestion})
    }
    setTimeout(() => {
      this.en_jeu_ref_DOM.current?.scrollIntoView({behavior: "smooth"});
    }, 300);
  }

  fermerQuestion(){
    const reussi = (this.state.reponse === this.state.currentQuestion?.reponse);
    if (reussi){
      if (this.valeur >=7){
        this.pm.app.audioManager.current?.play("ecus_3");
      } else if(this.valeur >=3){
        this.pm.app.audioManager.current?.play("ecus_2");
      } else {
        this.pm.app.audioManager.current?.play("ecus_1");        
      }
    }
    this.pm.app.gameManager.current?.fermerQuestion(reussi, this.code, this.valeur);
  }

  getEcusText(){
    const ecusText = (this.valeur > 1) ? "écus" : "écu";
    return ecusText;
  }

  handleSelectChoix(leChoix:CodesChoix){
    const questionEstRepondue = this.state.reponse !== null;
    if (questionEstRepondue) return;
          
    const reussi = (leChoix === this.state.currentQuestion?.reponse);
    if (reussi){
      this.pm.app.audioManager.current?.play("bonne_rep");
    } else {
      this.pm.app.audioManager.current?.play("mauvaise_rep");
    }
    
    setTimeout(() => {
      if (window.innerWidth < 1180){
        // Descendre l'écran sur mobile
        this.zonechoix_ref_DOM.current?.scrollIntoView({behavior: "smooth"});
      }
    }, 200);
    this.setState({reponse:leChoix});
  }

  getCodeQuestionNumerique(theCode:CodeQuestions){
    const indexCode = CodeQuestionListe.indexOf(theCode);
    const retourText = `${indexCode}`;
    return (retourText);
  }

  getRenderedPhrase(){
    const currentQuestion = this.state.currentQuestion;
    if (currentQuestion && currentQuestion.phrase){ 
      return(        
        <p className="phrase" dangerouslySetInnerHTML={{__html:currentQuestion.phrase}}></p>
      )
    }
    return null;
  }



  getRenderedAllChoix(){
    const currentQuestion = this.state.currentQuestion;
    const questionEstRepondue = this.state.reponse !== null;
    const choixFait = this.state.reponse;
    const bonneReponse = currentQuestion?.reponse;
    
    if (currentQuestion){
      const choixJsx = [];
      for (let i=0; i<ListeCodesChoix.length; i++){
        const curChoix = currentQuestion[`choix${ListeCodesChoix[i]}`];
        const curCodeChoix = ListeCodesChoix[i];

        if (curChoix){
          const afficherQuestionVerte = (questionEstRepondue && curCodeChoix === bonneReponse);
          const afficherQuestionRouge = (questionEstRepondue && (curCodeChoix !== bonneReponse) && (choixFait === curCodeChoix))

          choixJsx.push(             
            <button 
              className={clsx("choix", (afficherQuestionVerte && "bon"), (afficherQuestionRouge && "mauvais"))}
              key={`${currentQuestion.id}_choix${ListeCodesChoix[i]}`}
              onClick={() => (this.handleSelectChoix(ListeCodesChoix[i]))}
              dangerouslySetInnerHTML={{__html:curChoix}}
            >
            </button>
          )
        }
      }
      return choixJsx;
    }
    return null;
  }

  getRenderedBtnContinuer(){
    return(this.state.reponse !== null && (
      <div className="wrap-btn-continuer">
        <button className="continuer" onClick={() => {this.fermerQuestion()}}>Continuer</button>
      </div>
    )) 
  }
  
  render() {    
    return (
        <div className="popup question">
            <div className="entete">
                <div className="epreuve_no">
                    <h3>Épreuve numéro</h3>
                    <span>{this.getCodeQuestionNumerique(this.code)}</span>
                </div>
                <img src={imageCoffreMobile} className="coffre_mob" alt="Coffre" />
                <img src={imageCoffre} className="coffre_pc" alt="Coffre" />
                <div className="en_jeu" ref={this.en_jeu_ref_DOM}>
                  <h3>En jeu :</h3>
                  <span>{`${this.valeur} ${this.getEcusText()}`}<small className={clsx("debug", (!this.pm.app.urlParams.debug && "hidden"))}>{this.state.currentQuestion?.id}   Rép: {this.state.currentQuestion?.reponse}</small></span>
                </div>
            </div>
            <div className="zone_question">
              <div className="question">
                <p dangerouslySetInnerHTML={{__html:this.state.currentQuestion?.instruction || "nope"}} />
                {this.getRenderedPhrase()}
              </div>
            </div>
            <div className="zone_choix" ref={this.zonechoix_ref_DOM} >
              <div className={clsx("wrapper_choix", this.state.reponse !== null && "repondu")}>
                {this.getRenderedAllChoix()}
                {this.getRenderedBtnContinuer()}
              </div>
            </div>
            <div className="personnage">
              <img className="bulle_pc" src={img_bulle_perso_pc} alt="Bulle de pensée" />
              <img className="bulle_mob" src={img_bulle_perso_mob} alt="Bulle de pensée" />
              <div className="hero" />
            </div>
        </div>  
    )
  }
}

export default PopupQuestion;
